import { mimeTypeFilterPluginName, MimeTypeString, mimeTypeToGraphApiQueryString } from "@me8eon/mimetype_filter";
import { DataSourceWithGenerics, SearchQueryFn } from "@me8eon/data_sources";
import { DataHasType } from "@me8eon/data";
import { _makeGraphApiRequest, filtersToQueryString, GraphApiContext, GraphApiFilters, GraphApiPaging, GraphApiQuery } from "./graph.api.data.sources";

export const graphApiFiles = "graphApiFiles";
export const searchBodyForFilesGraphApi = (query: string, mimeType: MimeTypeString | undefined, dataVisible?: number | undefined): GraphApiQuery => {
    const mimeTypeQuery = (mimeType && mimeTypeToGraphApiQueryString[mimeType]) || "";
    const extraFilter = mimeTypeQuery ? `${mimeTypeQuery} and ` : "";
    return {
        requests: [
            {
                "entityTypes": ["driveItem"],
                query: {
                    queryString: extraFilter + query.trim(),
                },
                ...(dataVisible ? { size: dataVisible } : {}),
                selectProperties: [
                    "name",
                    "webUrl",
                    "createdDateTime",
                    "lastModifiedDateTime",
                    "size",
                    "file",
                    "jobTitle",
                    "mobilePhone",
                    "businessPhones",
                    "aboutMe",
                    "parentReference",
                    "hitHighlightedSummary",
                ],
            },
        ],
    };
};
export const graphApiFilesQuery = <Filters extends GraphApiFilters>(dataVisible?: number): SearchQueryFn<Filters, GraphApiPaging, GraphApiQuery> =>
    ({ filters }) => {
        return ({
            query: searchBodyForFilesGraphApi(filtersToQueryString(filters), filters[mimeTypeFilterPluginName], dataVisible),
            filters,
        })
    };

export function graphApiFilesDs<Filters extends GraphApiFilters>({ graphApiUrl, token, MakeGraphApiRequest = _makeGraphApiRequest }: GraphApiContext, dataVisible: number | undefined): DataSourceWithGenerics<Filters, GraphApiPaging, GraphApiQuery, any, DataHasType[]> {
    return {
        type: graphApiFiles,
        plugin: "datasource",
        results: (devModeData, source) => {
            const hitContainers = devModeData.flatMap((d: any) => d.hitsContainers || []);
            const results = hitContainers.flatMap((d: any) => d.hits || []).map((d: any) => ({ type: "sharepoint", ...d, source }));
            return { paging: {}, results, finished: true, aggregates: {} };
        },
        query: graphApiFilesQuery(dataVisible),
        search: (query) => MakeGraphApiRequest(graphApiUrl, token, query),
    };
}